import React from "react";

interface FlightRouteArcProps {
  /** Duration label rendered under the arc, e.g. "1h 35m". */
  duration?: string;
  className?: string;
}

/**
 * Dashed flight arc with a plane on it.
 *
 * The duration is drawn as real text rather than baked into the SVG so it can
 * change per flight.
 */
const FlightRouteArc: React.FC<FlightRouteArcProps> = ({
  duration,
  className = "",
}) => (
  <div className={`flex flex-col items-center ${className}`}>
    <svg
      viewBox="0 0 57 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full max-w-[57px] h-auto"
      aria-hidden="true"
    >
      <path
        d="M0.878418 27.4655C0.878418 27.4655 2.3261 0.879604 28.0853 0.879639C54.145 0.879674 55.2921 28.5507 55.2921 28.5507"
        stroke="#BDCDE6"
        strokeWidth="1.75925"
        strokeLinecap="round"
        strokeDasharray="0.05 4.34"
      />
      <path
        d="M41.7825 16.4118C41.2516 15.4144 40.9862 14.7019 37.0051 15.8418C35.8108 16.2693 34.6165 16.6968 33.5548 17.4093L32.4932 18.1217L22.275 14.9869L19.4883 16.5543L26.3889 22.1115L22.1423 24.8189L17.7631 23.394L15.9053 24.3914L20.2845 29.0937L36.8724 20.6866C37.9341 20.4016 42.5787 18.1217 41.7825 16.4118Z"
        fill="#192227"
      />
    </svg>

    {duration && (
      <span className="text-[10px] font-medium text-[#262626] mt-1 whitespace-nowrap">
        {duration}
      </span>
    )}
  </div>
);

export default FlightRouteArc;
